import classnames from "classnames";

import { HIGHLIGHT_RESPONSE_REGEX } from "@/components/Search/SearchBar/searchBar.config";
import { HighlightMatch } from "@/components/Search/SearchBar/searchBar.types";

type HighlightProps = {
    highlightMatch: HighlightMatch;
    reverseHighlight?: boolean;
};

const Highlight = ({
    highlightMatch,
    reverseHighlight = false
}: HighlightProps) => {
    const highlightedValue = highlightMatch.value.replace(
        HIGHLIGHT_RESPONSE_REGEX,
        `<mark class="${classnames(
            "p-0 bg-transparent",
            reverseHighlight ? "font-weight-normal" : "font-weight-bold"
        )}">$1</mark>`
    );

    return (
        <div
            className={classnames(reverseHighlight && "font-weight-bold")}
            dangerouslySetInnerHTML={{ __html: highlightedValue }}
        />
    );
};
export default Highlight;
